import { Box, Button, Grid, Paper, Stack, TextField, Typography } from "@mui/material";
import { message } from "antd";
import { useState } from "react";
import { Pin, Send } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from '@ant-design/icons';

const EnterOTP = () => {
    const [code, setCode] = useState();
    const [messageApi, contextHolder] = message.useMessage();
    const navigate = useNavigate();
    const [sending, setSending] = useState(false);

    const handleInputChange = (e) => {
        setCode(e.target.value);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSending(true);
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/forgot-password/otp-verify`,{
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({otp: code}),
        });
        const responseData = await response.json();
        setSending(false);
        if(response.status === 200) {
            messageApi.open({
                type: 'success',
                content: `${responseData.message}`,
                style: {
                  marginTop: '15vh',
                },
            });
            setTimeout(() => {
                navigate('/new-password');
            }, 1000);
        } else if (response.status === 401) {
            messageApi.open({
                type: 'error',
                content: `${responseData.error_message}`,
                style: {
                  marginTop: '15vh',
                },
            });
        }
    }

  return (
    <Box sx={{display: "flex" ,justifyContent: "center", padding: "50px", fontWeight: "500px"}}>
      {contextHolder}
      <Paper elevation={0} sx={{width: "400px", backgroundColor: "#ffff", margin: "100px"}}>
        <Grid className="form-title" container spacing={1}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5, fontWeight: "400", fontFamily: "Roboto Mono"}}>Enter CODE</Typography> </Grid>
          <Grid item> <Pin sx={{width: 40, height: 40}}/> </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>
          <Stack spacing={3} sx={{margin: "30px"}}>
            <p>Please check your email and enter code.</p>
            <TextField
              variant="standard"
              name="code"
              label="Code"
              size="small"
              value={code}
              onChange={handleInputChange}
            />
            <Grid container className="form-input-row">
              <Grid item>
               <Button variant="contained" color="success" size="medium" disableElevation type="submit" endIcon={sending ? <LoadingOutlined /> : <Send />}>Proceed</Button>
              </Grid>
            </Grid>
            </Stack>
        </form>
      </Paper>
    </Box>
  )
}

export default EnterOTP;
